import { c as _c } from "react/compiler-runtime";
import { BLOGS_API } from 'modules/blogs/api/blog-api';
import { BlogPagesApiInterface } from 'modules/blogs/types/blog-pages-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { CountInterface, SwrPaginationInterface } from 'shared/types/pagination-interface';
import { baseFetcher } from 'shared/utils/http-client';
import useSWR from 'swr';
interface UseBlogPagesInterface extends SwrPaginationInterface {
  id: string;
}
const sortOrder = {
  '': 1,
  posts: 2,
  default: Number.MAX_VALUE
};
export function useBlogPages(t0) {
  const $ = _c(13);
  const {
    id,
    pagination,
    limit
  } = t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get,
      afterFetch: _temp2
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  let t2;
  if ($[1] !== id || $[2] !== limit || $[3] !== pagination || $[4] !== user) {
    t2 = () => {
      if (user && pagination.startFromId === undefined && limit) {
        return `${BLOGS_API}/${id}/pages/list?pagination[limit]=${limit}`;
      } else {
        if (user && pagination.startFromId && limit) {
          return `${BLOGS_API}/${id}/pages/list?pagination[startFrom]=${pagination.startFromId}&pagination[order]=${pagination.order}&pagination[limit]=${limit}`;
        }
      }
      return null;
    };
    $[1] = id;
    $[2] = limit;
    $[3] = pagination;
    $[4] = user;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const {
    data: blogPages,
    mutate: blogPagesMutate
  } = useSWR(t2, fetcher);
  let t3;
  if ($[6] !== id || $[7] !== user) {
    t3 = () => {
      if (user) {
        return `${BLOGS_API}/${id}/pages/count?pagination[limit]`;
      }
      return null;
    };
    $[6] = id;
    $[7] = user;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const {
    data: blogPagesCounter
  } = useSWR(t3, baseFetcher);
  let t4;
  if ($[9] !== blogPages || $[10] !== blogPagesCounter || $[11] !== blogPagesMutate) {
    t4 = {
      blogPages,
      blogPagesMutate,
      blogPagesCounter
    };
    $[9] = blogPages;
    $[10] = blogPagesCounter;
    $[11] = blogPagesMutate;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}
async function _temp2(data) {
  return {
    ...data,
    items: [...data.items.sort(_temp)]
  };
}
function _temp(a, b) {
  return (sortOrder[a.path as keyof typeof sortOrder] || sortOrder.default) - (sortOrder[b.path as keyof typeof sortOrder] || sortOrder.default);
}